import { Box, Paper } from '@mui/material';
import React from 'react';
import { headerTypographyProps } from '../../../styles/sxStyling';
import { Integration } from '../../../types/Integration';
import { organizationCalendarStatus } from '../../organizations/organizationsStyles';

type Props = {
  integration: Integration;
};

export default function OutlookEventIntegration({ integration }: Props) {
  return (
    <Paper sx={{ display: 'flex', gap: '0.5rem', width: '100%', p: '0.5rem', alignItems: 'center' }}>
      <Box sx={{ ...headerTypographyProps, fontSize: '1rem' }}>Outlook Calendar -</Box>
      {integration?.settings?.calendar_name && (
        <Box sx={{ ...headerTypographyProps, fontSize: '0.875rem', fontWeight: 'normal' }}>{integration.settings.calendar_name} -</Box>
      )}
      <Box
        sx={{
          ...organizationCalendarStatus,
          backgroundColor: integration?.enabled ? 'var(--status-success)' : 'red',
          fontSize: '0.875rem',
        }}
      >
        {integration?.enabled ? 'Synced' : 'Not Synced'}
      </Box>
    </Paper>
  );
}
